export default __webpack_public_path__ + "media/images/next_blue_arrow_16-dfc55b911aadb309c4cf6669643d493c.png";